import React from "react";
import FieldCheck from "../FieldCheck";

export default class FilterCheck extends React.Component {
  getValue() {
    const {filter, path, name} = this.props;
    return this.props.getValue
      ? this.props.getValue({filter, path, name})
      : filter[path] && filter[path].$all.includes(name);
  }

  setValue({name, value}) {
    const {filter, path} = this.props;
    var newFilter = {...filter};
    if (this.props.setValue) {
      newFilter = this.props.setValue({filter: newFilter, path, name, value});
    } else {
      // default assumes a group of keys in an array to filter
      if (value) {
        // if the box is checked
        newFilter[path].$all.splice(newFilter[path].$all.indexOf(name), 1);
        if (newFilter[path].$all.length === 0) {
          delete newFilter[path];
        }
      } else {
        if (!newFilter[path]) {
          newFilter[path] = {$all: [name]};
        } else {
          newFilter[path].$all.push(name);
        }
      }
    }
    this.props.onChange({...this.props, filter: newFilter});
  }

  render() {
    const {label, name} = this.props;
    const value = this.getValue();
    return (
      <div className="filterCheckWrapper">
        <FieldCheck
          className="filterCheck"
          labelStyle={{width: "auto"}}
          label={label}
          name={name}
          value={value}
          onChange={({name, value}) => {
            this.setValue({name, value});
          }}
          checked={value}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterCheck/index.jsx